<template src="./popupWindow.html" />
<style scoped src="./popupWindow.css" />
  
<script>
export default {
    data() {
        return {
            show: false,
            message: "",
            callback: null,
        };
    },
    methods: {
        openPopup(message, callback) {
            this.message = message;
            this.callback = callback;
            this.show = true;
        },
        handleOKClick() {
            this.show = false;
            if (typeof this.callback === "function") {
                this.callback();
                this.callback = null; // Reset the callback after executing
            }
        },
    },
};
</script>
  